export default "__VITE_ASSET__Bltt0jSE__"